import AssessmentIcon from '@mui/icons-material/Assessment';
import ReportList from './ReportList';

const resource = {
  list: ReportList,
  icon: AssessmentIcon,
  
};

export default resource;
